import Vue from 'vue'

$(function () {
  $('body')
    .off('click.materialSelectCaret', '.select-wrapper .caret')
    .on('click.materialSelectCaret', '.select-wrapper .caret', function (e) {

      e.stopPropagation();

      const select = $(this).siblings('select');

      if (!select.next('.select-dropdown').hasClass('active')) {
        select.material_select('open');
      }
    });
});

Vue.component("material-select", {
  name:'material-select',
  template: '<select><slot></slot></select>',
  props: ['value'],
  watch: {
    value: function (value) {

      this.relaod(value);
    }
  },
  methods:{
    relaod : function (value) {

      var select = $(this.$el);

      select.val(value || this.value);
      select.material_select('destroy');
      select.material_select();
    }
  },
  mounted: function () {

    var vm = this;
    var select = $(this.$el);

    select
      .val(this.value)
      .on('change', function () {

        vm.$emit('input', this.value);
      });

    select.material_select();

  },
  updated: function () {

    this.relaod();
  },
  destroyed: function () {

    $(this.$el).material_select('destroy');
  }
});



// WEBPACK FOOTER //
// ./src/components/Shared/Material/MaterialSelect.js